import React from 'react';
import { UserContext } from '../context/UserContext';
import { Graph } from '../generated/graph';

interface Props extends React.Props<{}> {
  permission?: string
  permissionsAny?: any
  permissionsMust?: any
  showDenyText?: boolean
}

export class Permission extends React.Component<Props> {
  render() {
    return (
      <UserContext.Consumer>
        { value => this.renderComponent(value.user as Graph.User) }
      </UserContext.Consumer>
    )
  }

  renderComponent = (user: Graph.User) => {
    let access = user.superPermission || user.permissions!.indexOf(this.props.permission!) > -1;

    //If no permission is provide, render component normally
    if(this.props.permission === undefined && this.props.permissionsAny === undefined && this.props.permissionsMust === undefined) {
      access = true;
    } else {
      //Check array any permissions
      if(!user.superPermission && Array.isArray(this.props.permissionsAny)) {
        for(let i = 0; i < this.props.permissionsAny.length; i++) {
          if(user.permissions!.indexOf(this.props.permissionsAny[i]) > -1) {
            access = true;
            break;
          }
        }
      }

      //Check array must permissions
      if(!user.superPermission && Array.isArray(this.props.permissionsMust)) {
        for(let i = 0; i < this.props.permissionsMust.length; i++) {
          if(user.permissions!.indexOf(this.props.permissionsMust[i]) === -1) {
            access = false;
            break;
          } else {
            access = true;
          }
        }
      }
    }

    if(access) {
      return this.props.children;
    } else {
      return this.props.showDenyText ? <div className="text-danger">Permission denied.</div> : null;
    }
  }
}